var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.219,
    height: 9.602,
    viewBox: "0 0 19.219 9.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4199",
    "data-name": "Path 4199",
    d: "M27.083,16.7a1.537,1.537,0,0,0-1.424,2.124L21.1,23.069a1.529,1.529,0,0,0-1.315-.186l-1.457-1.836a1.538,1.538,0,1,0-2.908-.7,1.55,1.55,0,0,0,.026.228l-3.678,2.884a1.592,1.592,0,1,0,.645.85l3.556-2.789c.01.008.017.019.026.026a1.544,1.544,0,0,0,1.551.226l1.4,1.765a1.524,1.524,0,0,0-.239.808,1.54,1.54,0,1,0,3.081,0,1.525,1.525,0,0,0-.061-.406l4.66-4.336a1.519,1.519,0,0,0,.7.175,1.541,1.541,0,1,0,0-3.081ZM10.945,25.235a.474.474,0,1,1,.475-.474.474.474,0,0,1-.475.474Zm5.718-4.515a.473.473,0,1,1,.632-.035h0A.535.535,0,0,1,16.663,20.721Zm3.584,4.1a.474.474,0,0,1-.288-.85l.007,0h0a.464.464,0,0,1,.281-.093.475.475,0,0,1,0,.948Zm6.836-6.109a.474.474,0,1,1,.459-.474A.474.474,0,0,1,27.083,18.715Z",
    transform: "translate(-9.405 -16.701)",
    fill: "#f6c244"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.e3ceff54225fd4aaa789167c53083068.svg";
export { ForwardRef as ReactComponent };